import {
  APP_INITIALIZER,
  ApplicationConfig,
  importProvidersFrom,
  isDevMode,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { AppConfigService } from './app.config.service';
import { ThemeService } from './core/services/theme.service';
import { HttpClient, provideHttpClient, withFetch } from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { provideEnvironmentNgxMask } from 'ngx-mask';
import { TranslateHttpLoaderFactory } from './translate-loader';
import { provideServiceWorker } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { routes } from './app.routes';

export function HttpLoaderFactory(http: HttpClient, themeService: ThemeService) {
  return TranslateHttpLoaderFactory(http, themeService);
}

export function appInit(appConfigService: AppConfigService, themeService: ThemeService) {
  return async () => {
    await appConfigService.load();
    await themeService.init();
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: appInit,
      multi: true,
      deps: [AppConfigService, ThemeService],
    },
    provideRouter(routes),
    provideHttpClient(withFetch()),
    provideZoneChangeDetection({ eventCoalescing: true, runCoalescing: true }),
    provideServiceWorker('ngsw-worker.js', {
      enabled: environment.enableServiceWorker && !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000',
    }),
    // TODO - uncomment when SSR is enabled
    // provideClientHydration(),
    provideEnvironmentNgxMask(),
    importProvidersFrom(
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient, ThemeService],
        },
      })
    ),
  ],
};
